import { Grid } from '@mui/material';
import React from 'react';
import { APP_ROUTES } from '../../../common/constants/Routes';
import { useForm } from 'react-hook-form';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../../common/Header';
import { useTranslation } from 'react-i18next';
import FuelFrom from './FuelFrom';

function ViewFuel() {
  const { t } = useTranslation();
  const location = useLocation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    reset,
  } = useForm({
    defaultValues: {
      bunk_details_id: location.state.data?.data?.bunk_details_id || '',
      entry_date: location.state.data?.data?.entry_date || '',
      tank_capacity: location.state.data?.data?.tank_capacity || '',
      tank_id: location.state.data?.data?.tank_id || '',
      user_id: location.state.data?.data?.user_id || '',
      dip_reading: location.state.data?.data?.dip_reading || '',
      density: location.state.data?.data?.density || '',
      ullage: location.state.data?.data?.ullage || '',
      stock_fuel: location.state.data?.data?.stock_fuel || '',
      new_stock: location.state.data?.data?.new_stock || '',
      current_stock: location.state.data?.data?.current_stock || '',
    },
  });
  const navigate = useNavigate();
  const onSubmit = (data: any) => {
    console.log(data);
    navigate(APP_ROUTES.FUEL);
  };

  return (
    <Grid container mb={5}>
      <Grid xs={12} p={2}>
        <Header
          view={true}
          header={t('VIEW_FUEL')}
          route={APP_ROUTES.FUEL}
          buttonName={t('GO_BACK')}
          buttonIcon={SubdirectoryArrowRightIcon}
        />
      </Grid>
      <Grid xs={12}>
        <FuelFrom
          reset={reset}
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          control={control}
          register={register}
          errors={errors}
          watch={watch}
          view={true}
        />
      </Grid>
    </Grid>
  );
}

export default ViewFuel;
